/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';

export const Pagination = ({activePage, pageClickHandler, amountOfPages, amountToShow}) => (
    <ul className="pagination pagination-sm">
        <li className={activePage === 1 ? 'disabled' : ''}>
            <a href="#" aria-label="Previous" onClick={() => activePage !== 1 && pageClickHandler(activePage - 1)}>
                <span aria-hidden="true"/>
            </a>
        </li>
        <li className={activePage === 1 ? 'active' : ''}>
            <a href="#" onClick={() => pageClickHandler(1)}>1</a>
        </li>
        <li className={activePage - (amountToShow - 1) / 2 > 2 ? '' : 'hide'}>
            <a href="#" onClick={() => pageClickHandler(activePage - 3)}>...</a>
        </li>

        {Array(Math.ceil(amountOfPages - 2 < 0 ? 0 : amountOfPages - 2))
            .fill()
            .map((item, index) => (
                <li key={index + 1}
                    className={(activePage === index + 2 ? 'active' : '') + (activePage - (amountToShow - 1) / 2 > index + 2 || activePage + (amountToShow - 1) / 2 < index + 2 ? 'hide' : '')}>
                    <a onClick={() => pageClickHandler(index + 2)}>{index + 2}</a>
                </li>))}
        <li className={amountOfPages - activePage - (amountToShow - 1) / 2 >= 1.5 ? '' : 'hide'}>
            <a href="#" onClick={() => pageClickHandler(activePage + 3)}>...</a>
        </li>
        <li className={(activePage === Math.ceil(amountOfPages) ? 'active ' : '') + (amountOfPages <= 1 ? 'hide' : '')}>
            <a href="#" onClick={() => pageClickHandler(Math.ceil(amountOfPages))}>{Math.ceil(amountOfPages)}</a>
        </li>
        <li className={amountOfPages <= activePage ? 'disabled' : ''}>
            <a href="#" aria-label="Next"
               onClick={() => !(amountOfPages <= activePage) && pageClickHandler(activePage + 1)}>
                <span aria-hidden="true"/>
            </a>
        </li>
    </ul>
);

Pagination.propTypes = {
    activePage: PropTypes.number,
    amountOfPages: PropTypes.number,
    pageClickHandler: PropTypes.func,
    amountToShow: PropTypes.number,
};

Pagination.defaultProps = {
    activePage: 1,
    amountOfPages: 1,
    amountToShow: 10
};
